import styled, { css } from "styled-components"
import { StyledShowCountProps } from "../models"

const StyledSuffix = styled.span<StyledShowCountProps>`
  display: block;
  height: 0;
  opacity: 0;
  text-align: right;
  transform: translateY(0);
  transition: 0.2s all ease-in-out;
  visibility: hidden;
  ${(props) =>
    props.isFocus &&
    css`
      height: initial;
      visibility: visible;
      transform: translateY(15px);
      opacity: 1;
    `};
`

export const Styled = {
  StyledSuffix,
}
